export default "__VITE_PUBLIC_ASSET__6014d21c__"